import * as React from "react";

import { CoreDetailProps } from "../Detail";

const ContextItems: React.SFC<CoreDetailProps> = () => (
    <div />
);

export default ContextItems;
